import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskTimeDeltaUnitId {
  DAY = 'day',
  HOUR = 'hour',
}

export class TaskTimeDeltaUnit extends Codebook<TaskTimeDeltaUnitId> {
  static readonly DAY = new TaskTimeDeltaUnit(
    TaskTimeDeltaUnitId.DAY,
    () => $t('Days'),
    (value: number) => $t('{count} day | {count} days', value),
  )
  static readonly HOUR = new TaskTimeDeltaUnit(
    TaskTimeDeltaUnitId.HOUR,
    () => $t('Hours'),
    (value: number) => $t('{count} hour | {count} hours', value),
  )

  private constructor(
    id: TaskTimeDeltaUnitId,
    public readonly name: () => string,
    public readonly formattedValue: (value: number) => string,
  ) {
    super(id)
  }
}
